/* =========================================================
   O'SHOP — SUPPLÉMENTS PERSONNALISATION
   Impact / variant:add
   ========================================================= */

(function () {
  'use strict';

  const ADDONS = {
    nameNumber: 53887068405871, // 2,00 €
    bottomFlock: 53887069421679, // 1,00 €
    badge: 53887070601327       // 2,00 €
  };

  let processing = false;

  document.addEventListener('variant:add', async function (event) {

    if (processing) return;

    /* On cherche les champs de personnalisation présents sur la page */
    const nameInput = document.querySelector(
      '[name="properties[Nom & numéro]"]'
    );

    const bottomInput = document.querySelector(
      '[name="properties[Flocage bas]"]'
    );

    const badgeInput = document.querySelector(
      '[name="properties[Badge]"]:checked'
    );

    /* Ce n'est pas un produit avec notre personnalisation */
    if (!nameInput && !bottomInput && !badgeInput) {
      return;
    }

    const nameNumber = nameInput
      ? nameInput.value.trim()
      : '';

    const bottomFlock = bottomInput
      ? bottomInput.value.trim()
      : '';

    const badge = badgeInput
      ? badgeInput.value.trim()
      : '';

    const addonItems = [];

    /* =========================
       NOM + NUMÉRO = 2 €
       ========================= */

    if (nameNumber !== '') {
      addonItems.push({
        id: ADDONS.nameNumber,
        quantity: 1,
        properties: {
          '_Type': 'Nom & numéro',
          '_Personnalisation': nameNumber
        }
      });
    }

    /* =========================
       FLOCAGE BAS = 1 €
       ========================= */

    if (bottomFlock !== '') {
      addonItems.push({
        id: ADDONS.bottomFlock,
        quantity: 1,
        properties: {
          '_Type': 'Flocage bas',
          '_Personnalisation': bottomFlock
        }
      });
    }

    /* =========================
       BADGE = 2 €
       ========================= */

    if (
      badge !== '' &&
      badge.toLowerCase() !== 'aucun'
    ) {
      addonItems.push({
        id: ADDONS.badge,
        quantity: 1,
        properties: {
          '_Type': 'Badge',
          '_Badge': badge
        }
      });
    }

    if (addonItems.length === 0) {
      return;
    }

    processing = true;

    console.log(
      "O'SHOP — ajout suppléments :",
      addonItems
    );

    try {

      const root =
        window.Shopify?.routes?.root || '/';

      const response = await fetch(
        root + 'cart/add.js',
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },

          body: JSON.stringify({
            items: addonItems
          })
        }
      );

      const result = await response.json();

      if (!response.ok) {
        console.error(
          "O'SHOP — ERREUR AJOUT SUPPLÉMENTS :",
          result
        );

        return;
      }

      console.log(
        "O'SHOP — SUPPLÉMENTS AJOUTÉS ✅",
        result
      );

      /* On récupère le nouveau panier */
      const cartResponse = await fetch(
        root + 'cart.js'
      );

      const cart = await cartResponse.json();

      console.log(
        "O'SHOP — nouveau total panier :",
        cart.total_price / 100
      );

      /*
       * Impact écoute cart:change.
       * On lui transmet le nouveau panier.
       */
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            cart: cart
          }
        })
      );

    } catch (error) {

      console.error(
        "O'SHOP — ERREUR JS :",
        error
      );

    } finally {

      processing = false;

    }

  });

})();